import ShowAllSelectionsButton from './_show-all-selections-button.js'
import FlexPane from './_flex-pane.js'
import ButtonScrollPane from './_button-scroll-pane.js'
import Text from './_text.js'
import Market from './_market.js'
import PlayerInfo from './_player-info.js'

export default {
  name: 'MilestoneMarketContent',
  values: {
    showAllSelectionsButton: {
      configSet: ShowAllSelectionsButton,
      configValues: {},
    },
    rowsThreshold: 8,
    numberOfExpandedRows: 6,
    numberOfColumns: 6,
    _mobile_numberOfColumns: 2,
    showLastColumnPartly: false,
    _mobile_showLastColumnPartly: true,
    container: {
      configSet: FlexPane,
      configValues: {
        style: {
          flexDirection: 'column',
          padding: '8px',
        },
      },
    },
    innerContainer: {
      configSet: FlexPane,
      configValues: {
        itemSpacing: '8px',
      },
    },
    marketsScrollWrapper: {
      configSet: FlexPane,
      configValues: {
        itemSpacing: '4px',
        style: {
          flexDirection: 'column',
          justifyContent: 'flex-end',
          flexBasis: '70%',
          minWidth: 0,
        },
      },
    },
    marketsScrollContainer: {
      configSet: ButtonScrollPane,
      configValues: {
        scrollItemIntoViewBehavior: 'start',
        scrollFactor: 0.5,
        scrollPaneContainer: {
          style: {
            padding: '0',
          },
        },
        scrollPane: {
          scrollBarXDirectionOff: true,
        },
        leftScrollButtonContainer: {
          style: {
            height: 'auto',
            top: '-3px',
          },
        },
        rightScrollButtonContainer: {
          style: {
            height: 'auto',
            top: '-3px',
          },
        },
        leftScrollButton: {
          style: {
            base: {
              width: '40px',
              height: '40px',
            },
          },
        },
        rightScrollButton: {
          style: {
            base: {
              width: '40px',
              height: '40px',
            },
          },
        },
        leftScrollButtonIcon: {
          style: {
            width: '12px',
          },
        },
        rightScrollButtonIcon: {
          style: {
            width: '12px',
          },
        },
        contentContainer: {
          itemSpacing: '4px',
          style: {
            flexDirection: 'column',
            justifyContent: 'flex-end',
            minWidth: 0,
            maxWidth: '100%',
          },
        },
      },
    },
    headersWrapper: {
      configSet: FlexPane,
      configValues: {
        itemSpacing: '4px',
        style: {
          flexDirection: 'row',
          flexGrow: 0,
        },
      },
    },
    headerContainer: {
      configSet: FlexPane,
      configValues: {
        style: {
          flexShrink: 0,
          height: '18px',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'start',
        },
      },
    },
    headerLabel: {
      configSet: Text,
      configValues: {
        style: {
          textAlign: 'center',
        },
      },
    },
    market: {
      configSet: Market,
      configValues: {
        container: {
          itemSpacing: '4px',
          style: {
            flexGrow: 0,
            flexShrink: 1,
            flexBasis: 'auto',
          },
        },
        selectionsGroupContainer: {
          style: {
            flexDirection: 'row',
          },
        },
        selectionButton: {
          view: {
            nameDisplay: 'hide',
            _mobile_nameDisplay: 'hide',
            layoutDirection: 'horizontalAlignCenter',
            _mobile_layoutDirection: 'vertical',
            infoTextHandicapBase: {
              truncate: true,
              container: {
                flexShrink: 1,
              },
            },
          },
        },
      },
    },
    playersInfoListContainer: {
      configSet: FlexPane,
      configValues: {
        itemSpacing: '4px',
        style: {
          flexDirection: 'column',
          flexGrow: 1,
          flexBasis: '280px',
          _mobile_flexBasis: '107px',
          minWidth: '280px',
          _mobile_minWidth: '107px',
          padding: '32px 0 0 0',
        },
      },
    },
    playerInfo: {
      configSet: PlayerInfo,
      configValues: {},
    },
  },
  meta: {
    extendable: false,
  },
}
